export default __webpack_public_path__ + "static/media/table-spinner.96d3c61a.svg";